import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import React from 'react';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-account-center': {
                    id?: string;
                    'available-languages'?: string;
                    'user-dropdown-links'?: any;
                    authentication?: string;
                    environment?: string;
                    language?: string;
                    mode?: 'sg-markets';
                    debug?: string;
                    ref?: (elt: HTMLElement) => void;
                    'show-sign-in-button'?: boolean;
                };
            }
        }
    }
}

export const SgwtAccountCenter: React.FC = () => {
    return <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-account-center/v4/sgwt-account-center.js`}>
        <sgwt-account-center
            id="sgwtAccountCenter"
            language="en"
            available-languages="en"
            authentication="sg-connect-v2"
            mode="sg-markets"
            environment={configuration.sgConnectEnvironment?.toUpperCase() === 'PRODUCTION' ? undefined : configuration.sgConnectEnvironment || undefined}
        />
    </WidgetLazyLoader>;
};
